export default "__VITE_PUBLIC_ASSET__ffb8fd28__"